module.exports = __webpack_public_path__ + "f5ac65ef16cd71436a8b28a6fc2625ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/candy-s.png
// module id = 2616
// module chunks = 0